"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _get2 = _interopRequireDefault(require("lodash/get"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _parse = _interopRequireDefault(require("date-fns/parse"));
var _SearcherDateCarouselDesktop = _interopRequireDefault(require("../SearcherDateCarouselDesktop"));
var _SearcherDateCarouselItem = _interopRequireDefault(require("../SearcherDateCarouselItem"));
var _SearcherDateCarouselMobile = _interopRequireDefault(require("../SearcherDateCarouselMobile"));
var _userflow = require("../../constants/userflow");
var _fillDates = _interopRequireWildcard(require("./fillDates"));
var _date = require("../../utils/date");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var DatesCarousel = /*#__PURE__*/_react["default"].memo(function (_ref) {
  var isMobile = _ref.isMobile,
    dates = _ref.dates,
    startDate = _ref.startDate,
    carouselDate = _ref.carouselDate,
    fetching = _ref.fetching,
    onPriceDemand = _ref.onPriceDemand,
    onChangeCarouselDate = _ref.onChangeCarouselDate;
  var _useState = (0, _react.useState)(null),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    swiper = _useState2[0],
    updateSwiper = _useState2[1];
  var hasDates = Array.isArray(dates);
  var filledDates = (0, _fillDates["default"])(dates || [], startDate);
  var currentSlide = filledDates ? filledDates.findIndex(function (item) {
    return item.date === carouselDate;
  }) : _fillDates.DATES_OFFSET;
  var Carousel = isMobile ? _SearcherDateCarouselMobile["default"] : _SearcherDateCarouselDesktop["default"];
  var centerDate = (0, _get2["default"])(filledDates, [_fillDates.DATES_OFFSET, 'date']);
  var showSkeleton = !hasDates || fetching;
  (0, _react.useEffect)(function () {
    if (swiper && !fetching && currentSlide >= 0) {
      swiper.slideTo(currentSlide);
    }
  }, [fetching]);
  return /*#__PURE__*/_react["default"].createElement(Carousel, {
    key: centerDate,
    initialSlide: currentSlide,
    showSkeleton: showSkeleton,
    getSwiper: updateSwiper,
    onChange: isMobile ? onChangeCarouselDate : null
  }, filledDates.map(function (item) {
    var date = item.date,
      price = item.price,
      priceOnDemand = item.priceOnDemand,
      pricePerNight = item.pricePerNight;
    var prepareDate = (0, _parse["default"])(date, _userflow.DATE_FORMAT_CLIENT, new Date());
    var formattedDate = (0, _date.formatDate)(prepareDate, _userflow.DATE_FORMAT_WITH_DAY_OF_WEEK);
    return /*#__PURE__*/_react["default"].createElement(_SearcherDateCarouselItem["default"], {
      key: date,
      dateValue: date,
      date: formattedDate,
      active: carouselDate === date,
      onClick: function onClick() {
        if (priceOnDemand) {
          onPriceDemand(date);
        } else if (!isMobile) {
          onChangeCarouselDate(date);
        }
      },
      price: price,
      priceOnDemand: priceOnDemand,
      pricePerNight: pricePerNight
    });
  }));
});
DatesCarousel.displayName = 'DatesCarousel';
DatesCarousel.propTypes = {
  isMobile: _propTypes["default"].bool,
  fetching: _propTypes["default"].bool,
  dates: _propTypes["default"].arrayOf(_propTypes["default"].shape({
    date: _propTypes["default"].string.isRequired,
    price: _propTypes["default"].number
  }).isRequired),
  onChangeCarouselDate: _propTypes["default"].func,
  onPriceDemand: _propTypes["default"].func,
  carouselDate: _propTypes["default"].string.isRequired,
  startDate: _propTypes["default"].string.isRequired
};
DatesCarousel.defaultProps = {
  isMobile: false,
  fetching: false,
  dates: null,
  onChangeCarouselDate: Function.prototype,
  onPriceDemand: Function.prototype
};
var _default = exports["default"] = DatesCarousel;